var SENTRY_RELEASE;SENTRY_RELEASE={name: "Luna School App", version: "1.0.0"};